import { useEffect } from "react";

export default function useHidePopUp(popUpRef) {
  useEffect(() => {
    // popUpRef.forEach((ref) => { // Maybe for loop instead
      document.addEventListener("click", (e) => {
        if (popUpRef.current && e.target !== popUpRef.current) {
          popUpRef.current.style.display = "none";
        }
      });
    // });
  }, [popUpRef]);
  
}

